export enum ProcessingItemError {
  UploadFailed = 'UploadFailed',
  SignalRDisconnected = 'SignalRDisconnected',
}
